module.exports = __webpack_public_path__ + "img/file2.bba03250.svg";